import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { getSearchSuperyApi } from "../../Api/ClientServices";
import MenuBottom from "../../Component/menuBottom/MenuBottom";
import Style from "./HowToOrder.module.css";
import { errorToast } from "../../Toast/Toast";

const Supermarket = () => {
  const [searchValue, setSearchValue] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [, setFilter] = useState("");
  const [showSearchPart, setShowSearchPart] = useState();

  const getSearchSupermarket = async (value) => {
    getSearchSuperyApi(value, (succ, res) => {
      if (succ) {
        if (res.status === 0) {
          setShowSearchPart(false);
        } else {
          if (res.product?.length === 0 || res.product === null) { 
            setShowSearchPart(false);
          } else {
            const sortedProducts = res.product.sort((a, b) => Number(b.score) - Number(a.score));
            
            setSearchValue(sortedProducts); 
            setShowSearchPart(true);
          }
        }
      } else {
        console.error(res);
      }
    });
    setSearchInput(value);
  };
  
  return (
    <div>
      <div className={Style.searchHolder}>
        <input
          className={Style.search}
          placeholder={"جستجوی محصولات ..."}
          onChange={(e) => getSearchSupermarket(e.target.value)}
          type={"text"}
        />
        {searchInput.length === 0 || !showSearchPart ? null : (
          <ul className={Style.searchResult}>
            {searchValue?.map((item, index) => {
              return (
                <Link
                  to={{
                    pathname: `/product/${item.id}/${item.supplier_id}`,
                    state: item.id,
                  }}
                  className={Style.resultItem}
                  key={index}
                >
                  <div className={Style.imgHolder}>
                    <img
                      src={`https://cdn.barest.ir/product/m/${item.id}.jpg`}
                      alt="محصولات"
                    />
                  </div>
                  <div className={Style.productInfo}>
                    <h3 className={Style.productName}>{item.name}</h3>
                    {/* <h3 className={Style.supplierName}>
                    <FontAwesomeIcon
                      icon={faShoppingBag}
                      className={Style.shopIcon}
                    />
                    {item.supplier_name}
                  </h3> */}
                    <div className={Style.priceHolder}>
                      {item.off_price === 0 ? null : (
                        <h3 className={Style.offPrice}>
                          {item.off_price}تومان
                        </h3>
                      )}
                      {item.off_price === 0 ? (
                        <h3 className={Style.price}>{item.price}تومان</h3>
                      ) : (
                        <h3 className={Style.ofprice}>{item.price}تومان</h3>
                      )}
                    </div>
                  </div>
                </Link>
              );
            })}
            {/* <div className={Style.opacityPart}></div> */}
          </ul>
        )}
      </div>
      <div className={Style.khadamat}>
        <h3 className={Style.chose}>نوع سفارش کالا را انتخاب کنيد</h3>
        <Link to="/Products">
          <div className={`${Style.khadamatPart} ${Style.market}`}>
            <div className={Style.picPart}>
              <img
                src={"/Assets/Images/supermarket/products.png"}
                alt="خرید مستقیم"
              />
            </div>
            <h3>سفارش کالا بصورت مستقیم</h3>
          </div>
        </Link>
        <Link to="/Supermarkets">
          <div className={`${Style.khadamatPart} ${Style.product}`}>
            <div className={Style.picPart}>
              <img
                src={"/Assets/Images/supermarket/markets.png"}
                alt="خرید از فروشگاه"
              />
            </div>
            <h3>سفارش کالا از فروشگاه مورد نظر</h3>
          </div>
        </Link>
      </div>
      <MenuBottom />
    </div>
  );
};

export default Supermarket;
